var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        "is-show": _vm.isShowModel,
        "custom-title": _vm.$t("enote.title.enote"),
        "is-only-confirm": "",
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "enote-content" },
        [
          _vm._l(_vm.enoteList, function (item, index) {
            return _c("div", { key: index, staticClass: "enote-container" }, [
              item.type === "text"
                ? _c("div", { staticClass: "enote-item-text" }, [
                    _c("span", [_vm._v(_vm._s(item.data))]),
                  ])
                : item.type === "image"
                ? _c(
                    "div",
                    { staticClass: "enote-item-image" },
                    [
                      _c("el-image", {
                        attrs: {
                          src: item.data + "&token=" + _vm.sasToken,
                          "preview-src-list": [
                            item.data + "&token=" + _vm.sasToken,
                          ],
                          fit: "contain",
                        },
                      }),
                    ],
                    1
                  )
                : item.type === "record"
                ? _c("div", { staticClass: "enote-item-record" }, [
                    _c("audio", {
                      attrs: {
                        src: item.data + "&token=" + _vm.sasToken,
                        controls: "",
                      },
                    }),
                  ])
                : _vm._e(),
            ])
          }),
          _vm._v(" "),
          !_vm.enoteList.length
            ? _c("div", { staticClass: "enote-content-noData" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("enote.content.noData")) + "\n    "
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }